import Accounts from "../../components/admin/all-masters/accounts";

const AccountsPage = () => {
  return (
    <Accounts />
  );
};

export default AccountsPage;